import { render, staticRenderFns } from "./closedSpaceEdu.vue?vue&type=template&id=19b72a6a"
import script from "./closedSpaceEdu.vue?vue&type=script&lang=js"
export * from "./closedSpaceEdu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19b72a6a')) {
      api.createRecord('19b72a6a', component.options)
    } else {
      api.reload('19b72a6a', component.options)
    }
    module.hot.accept("./closedSpaceEdu.vue?vue&type=template&id=19b72a6a", function () {
      api.rerender('19b72a6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/closedSpaceEdu.vue"
export default component.exports